var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.errors.length > 0)?_c('div',{staticClass:"form-errors"},_vm._l((_vm.filteredErrors),function(error,index){return _c('p',{key:index,staticClass:"form-errors__entry"},[_vm._v(" "+_vm._s(error)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }